export default "__VITE_ASSET__BqDJK5hc__"